import { render } from "./OcrReportSidebarNav.vue?vue&type=template&id=2f64d59c"
import script from "./OcrReportSidebarNav.vue?vue&type=script&lang=js"
export * from "./OcrReportSidebarNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__